import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

import { settings } from 'config/languages'

import pl from './pl-PL.json'
import en from './en-EN.json'
import de from './de-DE.json'

const resources = {
   'pl-PL': {
      TRANSLATION: pl,
   },
   'en-EN': {
      TRANSLATION: en,
   },
   'de-DE': {
      TRANSLATION: de,
   },
}

i18n.use(initReactI18next).init({
   resources,
   lng: settings.defaultLang,
   fallbackLng: settings.fallbackLang,
   interpolation: {
      escapeValue: false,
   },
   debug: false,
})

export default i18n
